import { render, staticRenderFns } from "./admin-table-item.vue?vue&type=template&id=7bf8238d&"
import script from "./admin-table-item.vue?vue&type=script&lang=js&"
export * from "./admin-table-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports